import { formatarData, formatarFiltroDataApi, formatarPlaca } from 'src/app/core/utils/utilities';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { ITabelaMovimentacoesCaixa } from './listagem-caixa-model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalAcessoRestritoCaixaComponent } from '../modal-acesso-restrito-caixa/modal-acesso-restrito-caixa.component';
import { ModalSuprimentosCaixaComponent } from '../modal-suprimentos-caixa/modal-suprimentos-caixa.component';
import { ModalSangriaCaixaComponent } from '../modal-sangria-caixa/modal-sangria-caixa.component';
import { CaixaService } from 'src/app/services/CaixaService/caixa.service';
import { ServicoEntradaService } from 'src/app/services/ServicoEntradaService/servicoEntrada.service';
import { ModalRelatoriosMensaisCaixaComponent } from '../modal-relatorios-mensais-caixa/modal-relatorios-mensais-caixa.component';
import { IGetCaixaPagamentosByFilterPaginatedParams } from 'src/app/services/CaixaService/caixa.model';
import { ModalPagamentoCaixaComponent } from '../modal-pagamento-caixa/modal-pagamento-caixa.component';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { ImpressoraService } from 'src/app/services/ImpressoraService/impressora.service';
import { EntradaGateService } from 'src/app/services/EntradaGateService/entradaGate.service';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import { IGetServico } from 'src/app/services/ServicoService/servico.model';
import {
  IOpcaoAcao,
  IOpcaoTela
} from 'src/app/core/utils/permissionScreen/permissionScreen.types';
import { validarPermissao } from 'src/app/core/utils/permissionScreen/permissionScreen';

type IOptions = {
  name: string;
  value: string | number | null;
};

@Component({
  selector: 'app-listagem-caixa',
  templateUrl: './listagem-caixa.component.html',
  styleUrls: ['./listagem-caixa.component.scss']
})
export class ListagemCaixaComponent implements OnInit {
  form = this.initForm();
  guid = generateUUID();
  isLoading: boolean = false;
  expandirCardsMobile: boolean = true;
  valorTotalCaixa: number = 0;
  caixaOpen: boolean = false;
  caixaId: number | null = null;
  NU_TIPO_CAIX: number | null = null;
  tableData: ITabelaMovimentacoesCaixa[] | Array<any> = [];
  PAGE_NUMBER: number = 0;
  TOTAL_PAGES: number = 1;
  readonlyMode: boolean = false;

  tipoCaixaOptions: IOptions[] = [
    { name: 'Ambos', value: 0 },
    { name: 'Higienização', value: 1 },
    { name: 'Pátio', value: 2 }
  ];

  modoPagamentoOptions: IOptions[] = [
    { name: 'Cartão de Crédito', value: 1 },
    { name: 'Dinheiro', value: 9 },
    { name: 'Cartão de Débito', value: 19 },
    { name: 'Pix', value: 27 },
    { name: 'A Prazo', value: 28 }
  ];

  movimentacaoCaixaOptions: IOptions[] = [
    { name: 'Suprimento', value: 1 },
    { name: 'Sangria', value: 2 }
  ];

  servicoOptions: IOptions[] = [{ name: 'Todos', value: 0 }];

  tableColumns = [
    { header: 'Placa do Cavalo', key: 'TX_PLCA_CAVA', type: 'text' },
    { header: 'Serviço', key: 'TX_TIPO_SRVC', type: 'text' },
    { header: 'Data', key: 'DT_PGMT_SAID', type: 'text' },
    { header: 'Valor', key: 'VL_PGMT_SAID_CAIX', type: 'text' },
    { header: 'Modo de Pagamento', key: 'TX_TIPO_PGMT', type: 'text' },
    { header: 'Usuário', key: 'NM_FUNC', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Editar',
          img: 'assets/edit.svg',
          action: (item: any) => this.editMovimentacaoCaixa(item),
          condition: (item: any) => this.permitirEditar(item)
        },
        {
          label: 'Visualização',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.visualizarSaida(item),
          condition: (item: any) =>
            item.PK_MOVM_CAIX == null &&
            (!!item.PK_SRVC_ENTR || !!item.PK_GATE_ENTR)
        },
        {
          label: 'Baixar Ticket',
          img: 'assets/icon-download.svg',
          action: (item: any) =>
            this.downloadTicket(
              Number(item.PK_MOVM_CAIX),
              Number(item.NU_MOVM_CAIX),
              item
            ),
          condition: (item: any) => this.isViewTicket(item)
        },
        {
          label: 'Impressão Ticket',
          img: 'assets/icon-print.svg',
          action: (item: any) =>
            this.imprimirTicket(
              Number(item.PK_MOVM_CAIX),
              Number(item.NU_MOVM_CAIX),
              item
            ),
          condition: (item: any) => this.isViewTicket(item)
        }
      ]
    }
  ];

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    private caixaService: CaixaService,
    private servicoEntradaService: ServicoEntradaService,
    private appExportBase64: AppExportBase64,
    private impressoraService: ImpressoraService,
    private entradaGateService: EntradaGateService,
    private route: ActivatedRoute,
    private servicoService: ServicoService
  ) { }

  ngOnInit() {
    this.loadServicos();
    this.openCaixa();
    this.checkRouteParams();
    this.getMovimentacoesCaixa();
  }

  checkRouteParams() {
    this.route.queryParams.subscribe(params => {
      if (params['placa']) {
        this.form.patchValue({
          TX_PLCA_CAVA: params['placa']
        });
      }
    });
  }

  private initForm() {
    const form = this.fb.group({
      PK_CAIX: [null as number | null],
      TX_PLCA_CAVA: [''],
      NU_TIPO_PGMT: [0],
      DT_PGMT_SAID_INIC: [''],
      DT_PGMT_SAID_FIM: [''],
      NU_MOVM_CAIX: [0],
      NU_TIPO_CAIX: [0],
      FK_SRVC: [0]
    });
    return form;
  }

  getMovimentacoesCaixa(): void {
    this.isLoading = true;
    const params = this.createParams();
    this.caixaService.GetCaixaPagamentosByFilterPaginated(params).subscribe({
      next: res => {
        this.tableData = res.ITEMS.map(item => {
          return {
            PK_CAIX: item.PK_CAIX ?? '----',
            PK_MOVM_CAIX: item.PK_MOVM_CAIX,
            PK_PGMT_SAID: item.PK_PGMT_SAID,
            TX_PLCA_CAVA: formatarPlaca(item.TX_PLCA_CAVA) ?? '----',
            TX_TIPO_SRVC: item.TX_TIPO_SRVC ?? '----',
            DT_PGMT_SAID: formatarData(item.DT_PGMT_SAID) ?? '----',
            VL_PGMT_SAID_CAIX:
              item.VL_PGMT_SAID_CAIX.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }) ?? '----',
            NU_TIPO_PGMT_CAIX: item.NU_TIPO_PGMT_CAIX ?? '----',
            NM_FUNC: item.NM_FUNC ?? '----',
            NU_MOVM_CAIX: item.NU_MOVM_CAIX,
            TX_TIPO_PGMT:
              this.getModoPagamento(
                item.NU_MOVM_CAIX,
                item.NU_TIPO_PGMT_CAIX
              ) ?? '----',
            PK_GATE_ENTR: item.PK_GATE_ENTR,
            PK_SRVC_ENTR: item.PK_SRVC_ENTR,
            DT_ULTM_ATLZ: item.DT_ULTM_ATLZ,
            nuCaixSrvc: item.NU_CAIX_SRVC
          };
        });
        this.TOTAL_PAGES = res.TOTAL_PAGES;
        this.setValorTotalCaixa();
        setTimeout(() => {
          this.isLoading = false;
        }, 750);
      },
      error: err => {
        this.caixaOpen = false;
        this.isLoading = false;
      }
    });
  }

  createParams(): IGetCaixaPagamentosByFilterPaginatedParams {
    const pkCaix = this.getSelectedCaixaId();
    const placaRaw = String(this.form.get('TX_PLCA_CAVA')?.value ?? '');
    const placa = placaRaw.replace(/-/g, '').replace(/\s/g, '').trim();
    return {
      PK_CAIX: pkCaix,
      TX_PLCA_CAVA: placa || undefined,
      NU_TIPO_PGMT: Number(this.form.get('NU_TIPO_PGMT')?.value) || undefined,
      DT_PGMT_SAID_INIC: formatarFiltroDataApi(
        this.form.get('DT_PGMT_SAID_INIC')?.value as string | null
      ),
      DT_PGMT_SAID_FIM: formatarFiltroDataApi(
        this.form.get('DT_PGMT_SAID_FIM')?.value as string | null
      ),
      NU_MOVM_CAIX: Number(this.form.get('NU_MOVM_CAIX')?.value) || undefined,
      NU_TIPO_CAIX: Number(this.form.get('NU_TIPO_CAIX')?.value) || undefined,
      FK_SRVC: Number(this.form.get('FK_SRVC')?.value) || undefined,
      PAGE_NUMBER: this.PAGE_NUMBER,
      PAGE_SIZE: 8
    };
  }

  exportarExcelMovimentacoes(): void {
    const pkCaix = this.getSelectedCaixaId() ?? this.caixaId;
    if (!pkCaix) {
      return;
    }
    this.isLoading = true;
    const p: IGetCaixaPagamentosByFilterPaginatedParams = {
      ...this.createParams(),
      PK_CAIX: pkCaix
    };
    this.caixaService.GetCaixaMovimentacoesExcel(p).subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadExcel(
          response.ReportBase64,
          'movimentacao-caixa'
        );
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  openCaixa() {
    this.isLoading = true;
    this.caixaOpen = true;
    this.caixaService.GetCaixaAtual().subscribe({
      next: res => {
        if (!res?.PK_CAIX) {
          this.caixaOpen = false;
          this.isLoading = false;
          return;
        }
        this.caixaId = res.PK_CAIX;
        this.NU_TIPO_CAIX = res.NU_TIPO_CAIX ?? null;
        this.form.patchValue({ PK_CAIX: res.PK_CAIX }, { emitEvent: false });
        this.setValorTotalCaixa();
        this.isLoading = false;
      },
      error: err => {
        this.isLoading = false;
      }
    });
  }

  getModoPagamento(
    NU_MOVM_CAIX: number | null,
    NU_TIPO_PGMT_CAIX: number | null
  ): string {
    if (NU_MOVM_CAIX) {
      switch (NU_MOVM_CAIX) {
        case 1:
          return 'Suprimentos';
        case 2:
          return 'Sangria';
        default:
          return '----';
      }
    }
    if (NU_TIPO_PGMT_CAIX) {
      switch (NU_TIPO_PGMT_CAIX) {
        case 1:
          return 'Cartão de Crédito';
        case 19:
          return 'Cartão de Débito';
        case 27:
          return 'Pix';
        case 28:
          return 'A Prazo';
        case 29:
          return 'Faturado';
        case 9:
          return 'Dinheiro';
        default:
          return '----';
      }
    }
    return '----';
  }

  editMovimentacaoCaixa(item: any): void {
    if (item.TX_TIPO_PGMT === 'Suprimentos') {
      this.openModalSuprimentos(true, item);
    }
    if (item.TX_TIPO_PGMT === 'Sangria') {
      this.openModalSangria(true, item);
    }
    if (
      item.TX_TIPO_PGMT === 'Cartão de Crédito' ||
      item.TX_TIPO_PGMT === 'Cartão de Débito' ||
      item.TX_TIPO_PGMT === 'Pix' ||
      item.TX_TIPO_PGMT === 'A Prazo' ||
      item.TX_TIPO_PGMT === 'Dinheiro'
    ) {
      this.openModalPagamentoSaida(true, item);
    }
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getMovimentacoesCaixa();
    });
  }

  navigateNovaSaida() {
    this.router.navigate(['cadastro/caixa']);
  }

  setPagina(pagina: number) {
    this.PAGE_NUMBER = pagina + 1;
    this.getMovimentacoesCaixa();
  }

  openModalAberturaCaixa(): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '720px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      ABERTURA: true
    };

    const dialogRef = this.dialog.open(
      ModalAcessoRestritoCaixaComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.atualizarMovimentacoes) {
        this.getMovimentacoesCaixa();
      }
    });
  }

  openModalFechamentoCaixa(): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '720px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      FECHAMENTO: true,
      PK_CAIX: this.caixaId
    };

    const dialogRef = this.dialog.open(
      ModalAcessoRestritoCaixaComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.atualizarMovimentacoes) {
        this.getMovimentacoesCaixa();
      }
    });
  }

  openModalSuprimentos(edit?: boolean, item?: any): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '720px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      SUPRIMENTOS: true,
      PK_CAIX: this.caixaId,
      PK_MOVM_CAIX: item?.PK_MOVM_CAIX,
      EDIT_ITEM: edit
    };

    const dialogRef = this.dialog.open(
      ModalAcessoRestritoCaixaComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.atualizarMovimentacoes) {
        this.getMovimentacoesCaixa();
        if (edit && item) {
          this.imprimirTicket(
            Number(item.PK_MOVM_CAIX),
            Number(item.NU_MOVM_CAIX),
            item
          );
        }
      }
    });
  }

  openModalSangria(edit?: boolean, item?: any): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '720px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      SANGRIA: true,
      PK_CAIX: this.caixaId,
      PK_MOVM_CAIX: item?.PK_MOVM_CAIX,
      EDIT_ITEM: edit
    };

    const dialogRef = this.dialog.open(
      ModalAcessoRestritoCaixaComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.atualizarMovimentacoes) {
        this.getMovimentacoesCaixa();
        if (edit && item) {
          this.imprimirTicket(
            Number(item.PK_MOVM_CAIX),
            Number(item.NU_MOVM_CAIX),
            item
          );
        }
      }
    });
  }

  openModalPagamentoSaida(edit?: boolean, item?: any): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.maxWidth = '720px';
    dialogConfig.width = 'min(720px, 95vw)';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.panelClass = 'modal-pagamento-caixa-dialog';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      PK_CAIX: this.caixaId,
      PK_PGMT_SAID: item?.PK_PGMT_SAID,
      PK_GATE_ENTR: item?.PK_GATE_ENTR,
      EDIT_ITEM: edit ? true : false
    };

    const dialogRef = this.dialog.open(
      ModalPagamentoCaixaComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getMovimentacoesCaixa();
        if (edit && item && item.TX_PLCA_CAVA && item.TX_PLCA_CAVA !== '----') {
          this.router.navigate(['cadastro/laudo-higienizacao'], {
            queryParams: {
              placa: item.TX_PLCA_CAVA.replace('-', '')
            }
          });
        }
        if (edit && item) {
          this.imprimirTicket(
            Number(item.PK_MOVM_CAIX),
            Number(item.NU_MOVM_CAIX),
            item
          );
        }
      }
    });
  }

  openModalRelatoriosCaixa(): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '720px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {};

    this.dialog.open(ModalRelatoriosMensaisCaixaComponent, dialogConfig);
  }

  permitirEditar(item: any): boolean {
    if (this.NU_TIPO_CAIX === 2) return false;
    if (item.DT_ULTM_ATLZ) return false;

    if (item.TX_TIPO_PGMT === 'Sangria') {
      return this.viewMenu('cadastrarSangria', 'incluir');
    }
    if (item.TX_TIPO_PGMT === 'Suprimentos') {
      return this.viewMenu('cadastrarSangria', 'incluir');
    }
    return true;
  }

  onChangeTipoCaixa(event: number): void {
    this.form.controls['NU_TIPO_CAIX'].setValue(event);
  }

  onChangeModoPagamento(event: number): void {
    this.form.controls['NU_TIPO_PGMT'].setValue(event);
  }

  onChangeMovimentacaoCaixa(event: number): void {
    this.form.controls['NU_MOVM_CAIX'].setValue(event);
  }

  setValorTotalCaixa(): void {
    this.isLoading = true;
    const PK_CAIX = this.getSelectedCaixaId() ?? this.caixaId;
    const NU_TIPO_PGMT = this.form.controls['NU_TIPO_PGMT'].value;
    if (!PK_CAIX) return;
    const params = {
      PK_CAIX,
      NU_TIPO_PGMT
    };
    this.caixaService.GetCaixaTotalizadorById(params).subscribe({
      next: res => {
        this.valorTotalCaixa = res.VL_TOTL_CAIX;
        this.isLoading = false;
      },
      error: () => (this.isLoading = false)
    });
  }

  visualizarSaida(item: any) {
    if (item.PK_SRVC_ENTR) {
      const params = {
        isViewing: true,
        codigoGateEntrada: item.PK_GATE_ENTR,
        codigoServico: item.PK_SRVC_ENTR,
        placaCavalo: item.TX_PLCA_CAVA
      };
      this.router.navigate(['cadastro/servicos'], { queryParams: params });
    } else {
      const params = {
        isViewingCaixa: true,
        idEntrada: item.PK_GATE_ENTR
      };
      this.router.navigate(['cadastro/saida-gate'], { queryParams: params });
    }
  }

  downloadTicket(id: number, tipoMovimentacaoCaixa: number, item?: any) {
    this.isLoading = true;

    if (tipoMovimentacaoCaixa && id > 0) {
      this.caixaService
        .GetReceiptSuprimentoSangriaById(id, 0, tipoMovimentacaoCaixa)
        .subscribe({
          next: (response: IGetReportBase64) => {
            this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
            this.isLoading = false;
          },
          error: _error => {
            this.isLoading = false;
          }
        });
    } else if (item?.PK_SRVC_ENTR) {
      this.servicoEntradaService
        .GetReceiptServicoEntradaById(0, 0, item.PK_SRVC_ENTR, item.nuCaixSrvc === 2)
        .subscribe({
          next: (response: IGetReportBase64) => {
            this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
            this.isLoading = false;
          },
          error: _error => {
            this.isLoading = false;
          }
        });
    } else if (item?.PK_GATE_ENTR || (item as any)?.FK_GATE_ENTR || (item as any)?.idGateEntrada) {
      const gateId = item.PK_GATE_ENTR || (item as any).FK_GATE_ENTR || (item as any).idGateEntrada;
      this.entradaGateService
        .GetReceiptGateEntradaById(gateId, 0)
        .subscribe({
          next: (response: IGetReportBase64) => {
            this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
            this.isLoading = false;
          },
          error: _error => {
            this.isLoading = false;
          }
        });
    } else {
      this.isLoading = false;
    }
  }

  imprimirTicket(id: number, tipoMovimentacaoCaixa: number, item?: any) {
    this.isLoading = true;

    if (tipoMovimentacaoCaixa && id > 0) {
      this.caixaService
        .GetReceiptSuprimentoSangriaById(id, 1, tipoMovimentacaoCaixa)
        .subscribe({
          next: (response: IGetReportBase64) => {
            this.isLoading = false;
            this.impressoraService.impressoraTicket(
              response.ReportBase64,
              'text/plain'
            );
          },
          error: _error => {
            this.isLoading = false;
          }
        });
    } else if (item?.PK_SRVC_ENTR) {
      this.servicoEntradaService
        .GetReceiptServicoEntradaById(0, 1, item.PK_SRVC_ENTR, item.nuCaixSrvc === 2)
        .subscribe({
          next: (response: IGetReportBase64) => {
            this.isLoading = false;
            this.impressoraService.impressoraTicket(
              response.ReportBase64,
              'text/plain'
            );
          },
          error: _error => {
            this.isLoading = false;
          }
        });
    } else if (item?.PK_GATE_ENTR || (item as any)?.FK_GATE_ENTR || (item as any)?.idGateEntrada) {
      const gateId = item.PK_GATE_ENTR || (item as any).FK_GATE_ENTR || (item as any).idGateEntrada;

      this.entradaGateService
        .GetReceiptGateEntradaById(gateId, 1)
        .subscribe({
          next: (response: IGetReportBase64) => {
            this.isLoading = false;
            this.impressoraService.impressoraTicket(
              response.ReportBase64,
              'text/plain'
            );
          },
          error: _error => {
            this.isLoading = false;
          }
        });
    } else {
      this.isLoading = false;
    }
  }

  isViewTicket(item: any): boolean {
    let isVisible = false;

    if (item.NU_MOVM_CAIX == 2)
      isVisible = validarPermissao('cadastrarSangria', 'imprimir');

    if (item.NU_MOVM_CAIX == 1)
      isVisible = validarPermissao('cadastrarSuprimento', 'imprimir');

    if (item.PK_SRVC_ENTR) {
      isVisible = true;
    } else if (!item.NU_MOVM_CAIX && item.PK_GATE_ENTR) {
      isVisible = true;
    }

    return isVisible;
  }

  viewMenu(menu: IOpcaoTela, acao: IOpcaoAcao): boolean {
    return validarPermissao(menu, acao);
  }

  private getSelectedCaixaId(): number | undefined {
    const value = this.form.get('PK_CAIX')?.value;
    if (value === null || value === undefined) {
      return undefined;
    }
    const num = Number(value);
    return num > 0 ? num : undefined;
  }

  private loadServicos(): void {
    this.servicoService.GetServico().subscribe({
      next: response => {
        this.servicoOptions = [
          { name: 'Todos', value: 0 },
          ...response.map((servico: IGetServico) => ({
            name: servico.TX_TIPO_SRVC,
            value: servico.PK_SRVC
          }))
        ];
      }
    });
  }
}
